import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IPredictiveModelDetailInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetPredictiveModelByLuidParams extends IGetItemsParams {
  luid: string;
}

export class GetPredictiveModelByLuidRequest extends Request<IGetPredictiveModelByLuidParams, IPredictiveModelDetailInfo> {
  constructor(params: IGetPredictiveModelByLuidParams) {
    super('getPredictiveModelByLuid', params);
  }
}
